import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
  reportDetailsList: [],
  scheduleReportList: [],
  addScheduleReportList: [],
  groupList: [],
  planList: [],
}

const mutations = {
  SET_REPORTDETAILS_LIST(state, reportList) {
    var tData = {};
    var parseData = JSON.parse(reportList.message);
    if (Object.keys(state.reportDetailsList).length == 0) {
      tData[parseData.account_id + '-reportDetailsList'] = parseData;
      state.reportDetailsList = tData;
    } else {
      Vue.set(state.reportDetailsList, parseData.account_id + '-reportDetailsList', parseData);
    };
  },
  SET_SCHEDULEREPORT_LIST(state, scheduleReportList) {
    var tData = {};
    var parseData = JSON.parse(scheduleReportList.message);
    if (Object.keys(state.scheduleReportList).length == 0) {
      tData[parseData.account_id + '-scheduleReportList'] = parseData;
      state.scheduleReportList = tData;
    } else {
      Vue.set(state.scheduleReportList, parseData.account_id + '-scheduleReportList', parseData);
    };
  },
  DELETE_SCHEDULEREPORT_LIST(state, data) {
    if (Object.keys(state.scheduleReportList).length != 0) {
      for (var i = 0; i < state.scheduleReportList[data.accountId + "-scheduleReportList"].scheduleReports.length; i++) {
        if (state.scheduleReportList[data.accountId + "-scheduleReportList"].scheduleReports[i].ScheduleReport.id == data.ids) {
          state.scheduleReportList[data.accountId + "-scheduleReportList"].scheduleReports.splice(i, 1)
          break;
        }
      }
    }
  },
  SET_ADD_SCHEDULEREPORT_LIST(state, reportList) {
    var tData = {};
    var parseData = JSON.parse(reportList.message);
    if (Object.keys(state.addScheduleReportList).length == 0) {
      tData[parseData.account_id + '-addScheduleReportList'] = parseData;
      state.addScheduleReportList = tData;
    } else {
      Vue.set(state.addScheduleReportList, parseData.account_id + '-addScheduleReportList', parseData);
    };
  },
  CLEAR_REPORT_STATE(state) {
    state.reportDetailsList = [];
    state.scheduleReportList = [];
    state.addScheduleReportList = [];
  },
  SET_GROUP_LIST(state, groupList) {
    var tData = {};
    var parseData = groupList.groupList;
    if (Object.keys(state.groupList).length == 0) {
      tData['groupList'] = parseData;
      state.groupList = tData;
    } else {
      Vue.set(state.groupList, parseData);
    };
  },
  SET_PLAN_LIST(state, planList) {
    var tData = {};
    var parseData = planList.planList;
    if (Object.keys(state.planList).length == 0) {
      tData['planList'] = parseData;
      state.planList = tData;
    } else {
      Vue.set(state.planList, parseData);
    };
  },

}

const actions = {
  clearReportsState({
    commit,
    dispatch
  }) {
    commit('CLEAR_REPORT_STATE')
  },
  fetchScheduleReportDetailsList({
    commit,
    dispatch
  }) {
    Nprogress.start()
    axios.get('/reporting/schedule_report_details_list')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_SCHEDULEREPORT_LIST', res.data)
        }

      })
      .catch(error => console.log(error))
  },
  fetchReportDetailsList({
    commit,
    dispatch
  }) {
    Nprogress.start()
    axios.get('/reporting/report_details_list')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_REPORTDETAILS_LIST', res.data)
        }

      })
      .catch(error => console.log(error))
  },
  generateReportSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/reporting/generate_billing_report', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status == 'success' && response.data.shellReport != "yes" ) {
              var responseMessage = response.data.message;
              window.open("/backend" + responseMessage, "_blank");
          }
          resolve(response.data);

        })
        .catch(error => console.log(error));
    });
  },
  deleteScheduleReportModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/reporting/delete_schedule_report/' + postData.ReportId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            ids: response.data.successIds,
            accountId: postData.accountId
          }
          commit('DELETE_SCHEDULEREPORT_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchAddScheduleReportList({
    commit,
    dispatch
  }, postData) {
    if (postData != null) {
      var id = postData;
    } else {
      var id = null;
    }
    Nprogress.start()
    axios.get('/reporting/add_schedule_reporting_set/' + id)
      .then(res => {
        Nprogress.done()

        commit('SET_ADD_SCHEDULEREPORT_LIST', res.data)

      })
      .catch(error => console.log(error))
  },
  scheduleReportFormSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      if (postData.id != null) {
        var reportId = postData.id;
      } else {
        var reportId = 'add_schedule_reporting';
      }
      axios.post('/reporting/submit_schedule_reporting/' + reportId, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          response.data.message = "Report scheduled successfully";
          resolve(response.data.message);
        })
        .catch(error => console.log(error));
    });
  },
  fetchGroupDetailsList({
    commit
  }, postData) {
    var data = {
      accountId: postData,
    }
    Nprogress.start()
    axios.post('/reporting/groupDescription', qs.stringify(data, {
      parseArrays: false
    }))
      .then(res => {
        Nprogress.done()
        state.groupList = [];
        commit('SET_GROUP_LIST', res.data)

      })
      .catch(error => console.log(error))

  },
  fetchPlanDetailsList({
    commit
  }, postData) {
    var data = {
      accountId: postData,
    }
    Nprogress.start()
    axios.post('/reporting/planDescription', qs.stringify(data, {
      parseArrays: false
    }))
      .then(res => {
        Nprogress.done()
        state.planList = [];
        commit('SET_PLAN_LIST', res.data)

      })
      .catch(error => console.log(error))

  },
}

const getters = {
  reportDetailsListGetters: state => {
    return state.reportDetailsList;
  },
  scheduleReportListGetters: state => {
    return state.scheduleReportList;
  },
  addscheduleReportDetailsListGetters: state => {
    return state.addScheduleReportList;
  },
  groupListGetters: state => {
    return state.groupList;
  },
  planListGetters: state => {
    return state.planList;
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}